import { get } from "@Api/Action";
export const REPLACE_ACTIONS = "replaceActions";
const add = (dispatch, data) => {
    return dispatch({
        type: REPLACE_ACTIONS,
        data,
    });
};
export const fetchActions = (dispatch) => get().then((actions) => add(dispatch, actions));
